// extracted by mini-css-extract-plugin
export var ionArrowRightC = "project_carousel-module--ion-arrow-right-c--13f9b";
export var portfolioCaption = "project_carousel-module--portfolio-caption--6ada4";
export var portfolioFull = "project_carousel-module--portfolio-full--2fedc";
export var portfolioGrid2 = "project_carousel-module--portfolio-grid-2--677e7";
export var portfolioGrid4 = "project_carousel-module--portfolio-grid-4--4729e";
export var portfolioItem = "project_carousel-module--portfolio-item--65f0d";
export var portfolioMosaic = "project_carousel-module--portfolio-mosaic--07e48";
export var portfolioViewBtn = "project_carousel-module--portfolio-view-btn--a1bb1";
export var portfolioWrapper = "project_carousel-module--portfolio-wrapper--d7c75";
export var sliderDesktop = "project_carousel-module--slider-desktop--e9533";
export var sliderMobile = "project_carousel-module--slider-mobile--2b101";